import { create } from 'zustand'
import axios from 'axios'
import type { ScanInventoryType } from 'Utils/scanInventoryType'

interface InventoryLookupOptions {
  type?: ScanInventoryType
  itemId?: string
  soNo?: string
}

interface InventoryStore {
  selected: any
  data: any[]
  loading: boolean
  error?: any
  getOne: (
    inventoryCode: string,
    options?: InventoryLookupOptions
  ) => Promise<{ success: boolean; data: any }>
  setSelected: (selected: any) => void
}

export const API_SLUG = 'inventory'

export const useInventoryStore = create<InventoryStore>(set => ({
  data: [],
  selected: null,
  loading: false,
  error: undefined,
  setLoading: (loading: boolean) => {
    set({ loading })
  },
  setError: (error: any) => {
    set({ error })
  },
  setSelected: (selected: any) => {
    set({ selected })
  },

  getOne: async (inventoryCode, options) => {
    set({ loading: true })

    const params: Record<string, string> = {}
    if (options?.type) params.type = options.type
    if (options?.itemId) params.itemId = options.itemId
    if (options?.soNo) params.soNo = options.soNo

    return axios
      .get(`/${API_SLUG}/${encodeURIComponent(inventoryCode)}`, {
        params: Object.keys(params).length > 0 ? params : undefined,
      })
      .then(res => {
        set({ selected: res.data })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },

  clearState: () => {
    set({
      data: [],
      loading: false,
      error: undefined,
      selected: null,
    })
  },
}))
